import { render, staticRenderFns } from "./nobleAgreement.vue?vue&type=template&id=2c80fa3e&scoped=true&"
import script from "./nobleAgreement.vue?vue&type=script&lang=js&"
export * from "./nobleAgreement.vue?vue&type=script&lang=js&"
import style0 from "./nobleAgreement.vue?vue&type=style&index=0&id=2c80fa3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c80fa3e",
  null
  
)

export default component.exports